import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../../Utilities/DataLayer';
import Formatter from '../../Utilities/Formatter';

class UnitListCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flipped: false,
            extendedData: []
        }
        this.handleFlipping = this.handleFlipping.bind(this);
        this.addToWatch = this.addToWatch.bind(this);
        this.loadUnitDemonstrators = this.loadUnitDemonstrators.bind(this);
        this.getButtons = this.getButtons.bind(this);
        this.getCardHeader = this.getCardHeader.bind(this);
        this.formatter = new Formatter();
    }

    async handleFlipping() {
        if (!this.state.flipped) {
            this.props.loaderOn();
            var dl = new DataLayer();
            await dl.Get('/common/getunitstats?demId=' + this.props.sfId + '&unitId=' + this.props.unitId, 200).then((response) => {
                this.setState({
                    extendedData: response.data,
                    flipped: !this.state.flipped
                })
                this.props.loaderOff();
            })
        } else {
            this.setState({
                flipped: !this.state.flipped
            })
        }
    }

    loadUnitDemonstrators = (unitId, unitName) => {
        const { history } = this.props;
        history.push({
            pathname: '/salesforce/demonstratorlist/0',
            search: 'unitId=' + unitId,
            state: { detail: unitName }
        })
    }

    addToWatch = (sfId, unitId) => {
        this.setState({ isLoading: true });
        var dl = new DataLayer();
        dl.Get('/common/AddToWatchList?sfId=' + sfId + '&unitId=' + unitId, 200).then((response) => {
            this.setState({ isLoading: false });
            alert('Added To Watch Successfully');
        })
    }

    getCardHeader() {
        let telNo = "tel:" + this.props.telephoneCell;
        if (this.props.isPromoteoutList) {
            return (
                <div>
                    <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{this.props.unitName.toUpperCase()}<div style={{ fontSize: "15px" }} className="float-right">Active&nbsp;{this.props.active ? (<MDBIcon icon="user-check" style={{ color: "green" }} />) : (<MDBIcon icon="user-times" style={{ color: "red" }} />)} </div></MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.managerName.toUpperCase()}<div style={{ fontSize: "14px" }} className="float-right">Status:&nbsp;{this.props.status}</div></MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="phone" />&nbsp;&nbsp;<a href={telNo}>{this.props.telephoneCell}</a></MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>Unit Start: {this.props.startWeekId}</MDBCardTitle>
                    {this.props.endWeekId == null ? (<div></div>) : (<MDBCardTitle style={{ fontSize: "14px" }}>Unit End: {this.props.endWeekId}</MDBCardTitle>)}
                    <hr />
                    <MDBCardText>
                        <span>Curr. Segment Sales: <strong>{this.formatter.formatCurrency(this.props.sales)}</strong></span><br />
                        <span>Prev. Segment Sales: {this.formatter.formatCurrency(this.props.prevSegmentSales)}</span>
                    </MDBCardText>
                </div>
            )
        } else {
            return (
                <div>
                    <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{this.props.unitName.toUpperCase()}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.managerName.toUpperCase()}</MDBCardTitle>
                    <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="phone" />&nbsp;&nbsp;<a href={telNo}>{this.props.telephoneCell}</a></MDBCardTitle>
                    <hr />
                    <MDBCardText>
                        <span>Curr. Segment Sales: <strong>{this.formatter.formatCurrency(this.props.sales)}</strong></span><br />
                        <span>Prev. Segment Sales: {this.formatter.formatCurrency(this.props.prevSegmentSales)}</span>
                    </MDBCardText>
                </div>
            )
        }
    }

    getButtons() {
        if (this.props.isPromoteoutList) {
            return (
                <div className="flex-row text-center">
                    <MDBBtn tag="a" floating color="cyan" onClick={this.handleFlipping}>
                        <MDBIcon icon="info" />
                    </MDBBtn>
                </div>
            )
        } else {
            return (
                <div className="flex-row text-center">
                    <MDBBtn tag="a" color="purple" floating onClick={() => this.addToWatch(this.props.sfId, this.props.unitId)}>
                        <MDBIcon icon="glasses" />
                    </MDBBtn>

                    <MDBBtn tag="a" floating color="cyan" onClick={this.handleFlipping}>
                        <MDBIcon icon="info" />
                    </MDBBtn>
                    <MDBBtn tag="a" floating color="pink" onClick={() => this.loadUnitDemonstrators(this.props.unitId, this.props.unitName)}>
                        <MDBIcon icon="users" />
                    </MDBBtn>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {!this.state.flipped ? (
                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                        {this.getCardHeader()}
                        <hr />

                        {this.getButtons()}

                    </MDBCard>
                ) : (
                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>

                            <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>Unit Detail: {this.state.extendedData.managerName}</MDBCardTitle>
                            <hr />
                            <MDBCardText>
                                <MDBRow>
                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                        <span style={{ fontSize: "14px" }}>Personal Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.personalSales)}</strong>
                                    </MDBCol>
                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                        <span style={{ fontSize: "14px" }}>Unit Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.unitSales)}</strong>
                                    </MDBCol>
                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                        <span style={{ fontSize: "14px" }}>Promoteout Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.promoteOutSales)}</strong>
                                    </MDBCol>
                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                        <span style={{ fontSize: "14px" }}>Total Unit Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.totalUnitSales)}</strong>
                                    </MDBCol>
                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                        <span style={{ fontSize: "14px" }}>New Recruits</span><br /> <strong>{this.state.extendedData.newRecruits}</strong>
                                    </MDBCol>
                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                        <span style={{ fontSize: "14px" }}>Qualified Recruits</span><br /> <strong>{this.state.extendedData.qualifiedRecsInSeg}</strong>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCardText>
                            <hr />
                            <div className="flex-row text-center" >
                                <MDBBtn tag="a" color="grey" floating onClick={this.handleFlipping}>
                                    <MDBIcon icon="undo-alt" />
                                </MDBBtn>
                            </div>
                        </MDBCard>
                    )}
            </div>
        )
    }
}

export default UnitListCard;